module.exports = __webpack_public_path__ + "img/logo.e232e5a7.png";